const STORAGE_KEY = 'conversation-details:panel';

/**
 * Read the persisted open/closed state of the Conversation Details panel.
 * Falls back to `defaultOpen` when nothing is stored or storage is unavailable.
 */
export function readShowConversationDetails(defaultOpen = true): boolean {
	try {
		const raw = window.localStorage.getItem(STORAGE_KEY);
		if (raw === null) return defaultOpen;
		return raw === 'true';
	} catch {
		return defaultOpen;
	}
}

/** Persist the open/closed state of the Conversation Details panel. */
export function writeShowConversationDetails(show: boolean): void {
	try {
		window.localStorage.setItem(STORAGE_KEY, String(show));
	} catch {
		// ignore storage failures (private mode, etc.)
	}
}
